import { render } from "./ThinkingAreaList.vue?vue&type=template&id=943a4bfa"
import script from "./ThinkingAreaList.vue?vue&type=script&lang=js"
export * from "./ThinkingAreaList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__